import React from 'react';
import { IconAdd } from '@bynder/icons';
import { Button } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { track } from '../../helpers/analytics';
import { useSectionMutations } from '../../mutations/sections';
import { generateUUID } from '../../helpers/utils';

interface Props {
  sectionIndex: number;
  sectionCount: number;
  isVisible?: boolean;
  disabled?: boolean;
}

export const AddSectionButton: React.FC<Props> = ({
  sectionIndex,
  sectionCount,
}) => {
  const { translate } = useTranslate();
  const { addSection } = useSectionMutations();

  const handleClick = () => {
    const isNotFirst = sectionIndex !== 0;
    const isNotLast = sectionIndex !== sectionCount;

    track('Section Added', {
      'Between Sections': isNotFirst && isNotLast,
    });

    const sectionId = generateUUID();
    addSection.mutate({ sectionId, sectionPosition: 0 });
  };

  return (
    <Button icon={<IconAdd />} onClick={handleClick}>
      {translate('WIDGET_MENU.ADD_SECTION_TITLE')}
    </Button>
  );
};
